import apiClient from "../apiClient";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { BuildingControlProjectsType } from "../../Controllers/Types/BuildingControl/BuildingControlProjectsType";
import { baseURL } from "../ApiConstant";

// For get all building control projects
export const getAllBuildingControlProjects = async () => {
    try {
        const response = await apiClient.get(`/api/building-control-project-data`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        // Handle error (display error message, log, etc.)
        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// For Add project to the building control
export const addProjectForBuildingControl = async (projectList: BuildingControlProjectsType[]): Promise<CommonApiResponse> => {
    try {
        // prepare ids for number list
        const list = projectList.map((e) => e.project_id);

        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/building-control-project-add`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ list }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// ---------------------------------------- Building control quotation
// Get Building inspection companies
export const getBuildingInspectionCompanies = async () => {
    try {
        const response = await apiClient.get(`/api/bic-company-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching building inspection companies:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Get Building control quotations
export const getBuildingControlQuotations = async (role: 'architect' | 'client') => {
    try {
        let endPoint = '';

        if (role === 'architect') {
            endPoint = '/api/bc-quotation-data-arc';
        } else if (role === 'client') {
            endPoint = '/api/bc-quotation-data-client';
        }
        const response = await apiClient.get(endPoint);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching building control quotations:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Get Building control quotation requests
export const getBuildingControlQuotationRequests = async () => {
    try {
        const response = await apiClient.get(`/api/bc-quotation-request-bic`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching building control quotation requests:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Create building control quotation
export const createBuildingControlQuotationAPI = async (
    project_id: number,
    project_name: string,
    project_address: string,
    share_list: number[],
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-quotation-create-arc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                project_id,
                project_name,
                project_address,
                share_list
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, massage: "Quotation created successfully" };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Please check your entered values",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Create building control quotation response ARC
export const createQuotationARCResponseAPI = async (
    bc_quotation_id: number,
    company_id: number,
    reponce: string,
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-quotation-request-responce-add-arc`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                bc_quotation_id,
                company_id,
                reponce
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, massage: "Response added successfully" };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Please check your entered values",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Create building control quotation response BIC
export const createQuotationBICResponseAPI = async (
    bc_quotation_id: number,
    reponce: string,
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/bc-quotation-request-responce-bic`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({
                bc_quotation_id,
                reponce
            }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, massage: "Response added successfully" };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Please check your entered values",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};